import { render } from "./SendEmailButton.vue?vue&type=template&id=3f55564e"
import script from "./SendEmailButton.vue?vue&type=script&lang=js"
export * from "./SendEmailButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__